import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { useTranslation } from 'common/src/hooks/useTranslation';
import { Alert, LoadingState } from '../ui';
import { BoxFormatMappingSection } from './FruticBoxMapping';

/**
 * Mapeo de formatos en un modal: el mismo en Despachos, el Gestor de Arribos y
 * la edición de liquidaciones. Guardar un mapeo actualiza las cajas en la base
 * (trigger), así que quien lo abre suele recargar al cerrarlo.
 */
const FormatMappingModal = ({
  isOpen,
  onClose,
  speciesId,
  season,
  exporterId,
  exporterRef,
  loading = false,
  error,
  onRetry,
}: {
  isOpen: boolean;
  onClose: () => void;
  speciesId?: number | null;
  season?: string | null;
  exporterId?: number;
  exporterRef?: string;
  loading?: boolean;
  error?: string | null;
  onRetry?: () => void;
}) => {
  const { t } = useTranslation('shipments');
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placement='center'
      size='5xl'
      scrollBehavior='inside'
    >
      <ModalContent>
        {(close) => (
          <>
            <ModalHeader>{t('Mapeo de formatos')}</ModalHeader>
            <ModalBody>
              {loading ? (
                <LoadingState />
              ) : error ? (
                <Alert variant='danger' showIcon>
                  <div className='flex flex-wrap items-center justify-between gap-3'>
                    <span>{error}</span>
                    {onRetry && (
                      <Button size='sm' variant='flat' onPress={onRetry}>
                        {t('Reintentar')}
                      </Button>
                    )}
                  </div>
                </Alert>
              ) : speciesId && season ? (
                <BoxFormatMappingSection
                  speciesId={speciesId}
                  season={season}
                  exporterId={exporterId}
                  exporterRef={exporterRef}
                  defaultExpanded
                />
              ) : null}
            </ModalBody>
            <ModalFooter>
              <Button variant='light' onPress={close}>
                {t('Cerrar')}
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default FormatMappingModal;
